import { useMutation } from '@tanstack/react-query';
import ConnectionService from '../../../Domain/Connections/Services/ConnectionService';

type ConnectionApproveDraftData = {
  connectionId: string;
  batchId: string;
  externalIds: string[];
};

const mutationFn = (data: ConnectionApproveDraftData) => {
  return ConnectionService.approveDraftBatch(data);
};

export const useConnectionApproveDraftMutation = () => {
  return useMutation<unknown, unknown, ConnectionApproveDraftData>(mutationFn);
};
